import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex min-h-0 flex-1 flex-col"
};
const _hoisted_2 = {
  class: "data-table-shell"
};
const _hoisted_3 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_4 = {
  key: 0,
  class: "w-full"
};
const _hoisted_5 = {
  class: "data-table min-w-[960px]"
};
const _hoisted_6 = {
  class: "data-table-head"
};
const _hoisted_7 = {
  class: "data-table-th text-left"
};
const _hoisted_8 = {
  key: 0,
  class: "data-table-th text-left"
};
const _hoisted_9 = {
  key: 1,
  class: "data-table-th text-left"
};
const _hoisted_10 = {
  class: "data-table-th text-left"
};
const _hoisted_11 = {
  class: "data-table-th is-right"
};
const _hoisted_12 = {
  class: "data-table-th is-right"
};
const _hoisted_13 = {
  class: "data-table-th is-center"
};
const _hoisted_14 = {
  class: "data-table-th is-center"
};
const _hoisted_15 = {
  class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
};
const _hoisted_16 = {
  class: "data-table-body data-table-skeleton"
};
const _hoisted_17 = {
  key: 0,
  class: "data-table-td"
};
const _hoisted_18 = {
  key: 1,
  class: "data-table-td"
};
const _hoisted_19 = {
  class: "mb-2 text-lg font-medium text-slate-900"
};
const _hoisted_20 = {
  class: "text-slate-500"
};
const _hoisted_21 = {
  key: 2,
  class: "data-table min-w-[960px]"
};
const _hoisted_22 = {
  class: "data-table-head"
};
const _hoisted_23 = {
  class: "data-table-th text-left"
};
const _hoisted_24 = {
  key: 0,
  class: "data-table-th text-left"
};
const _hoisted_25 = {
  key: 1,
  class: "data-table-th text-left"
};
const _hoisted_26 = {
  class: "data-table-th text-left"
};
const _hoisted_27 = {
  class: "data-table-th is-right"
};
const _hoisted_28 = {
  class: "data-table-th is-right"
};
const _hoisted_29 = {
  class: "data-table-th is-center"
};
const _hoisted_30 = {
  class: "data-table-th is-center"
};
const _hoisted_31 = {
  class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
};
const _hoisted_32 = {
  class: "data-table-body"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  class: "data-table-td"
};
const _hoisted_35 = {
  class: "flex items-center gap-3"
};
const _hoisted_36 = {
  class: "data-table-cell-title"
};
const _hoisted_37 = {
  class: "data-table-cell-meta"
};
const _hoisted_38 = {
  key: 0,
  class: "data-table-td"
};
const _hoisted_39 = ["onClick"];
const _hoisted_40 = {
  key: 1,
  class: "text-sm text-slate-600"
};
const _hoisted_41 = {
  key: 1,
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_42 = {
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_43 = {
  class: "flex items-center gap-2"
};
const _hoisted_44 = {
  class: "data-table-td is-right text-sm font-medium text-slate-900"
};
const _hoisted_45 = {
  class: "data-table-td is-right text-sm font-medium text-primary-600"
};
const _hoisted_46 = {
  key: 0,
  class: "status-badge mr-1 bg-slate-100 text-slate-600"
};
const _hoisted_47 = ["title"];
const _hoisted_48 = ["title", "aria-label", "onClick"];
const _hoisted_49 = {
  class: "data-table-td is-center text-sm text-slate-600"
};
const _hoisted_50 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_51 = ["title", "aria-label", "onClick"];
const _hoisted_52 = ["title", "aria-label", "onClick"];
import { computed } from 'vue';
import AppPagination from '@/components/AppPagination.vue';
export default {
  __name: 'ProposalListTable',
  props: {
    plans: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({
        current: 1,
        page: 1,
        size: 20,
        total: 0,
        pages: 0
      })
    },
    showCustomerColumn: {
      type: Boolean,
      default: true
    },
    showCompanyColumn: {
      type: Boolean,
      default: true
    },
    customerLinkable: {
      type: Boolean,
      default: true
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    compactEmpty: {
      type: Boolean,
      default: false
    },
    emptyDescription: {
      type: String,
      default: '\u60a8\u53ef\u4ee5\u521b\u5efa\u4e00\u4e2a\u65b0\u7684\u62a5\u4ef7\u65b9\u6848\u6765\u5f00\u59cb\u3002'
    }
  },
  emits: ['detail', 'edit', 'approval-detail', 'customer-click', 'page-change', 'size-change'],
  setup(__props, {
    emit: __emit
  }) {
    const text = {
      proposalInfo: '方案信息',
      customer: '客户',
      company: '客户企业',
      owner: '规划师',
      totalAmount: '总金额',
      payableAmount: '应付金额',
      status: '状态',
      createTime: '创建时间',
      action: '操作',
      empty: '暂无方案数据',
      draft: '草稿',
      executing: '执行中',
      completed: '已完成',
      cancelled: '已取消',
      pendingApproval: '待审批',
      approvalRejected: '审批驳回',
      unknown: '未知',
      needApproval: '当前方案需要审批',
      viewApproval: '查看审批详情',
      viewDetail: '查看详情',
      edit: '编辑',
      total: '共',
      item: '条',
      prev: '上一页',
      next: '下一页',
      perPage: '每页'
    };
    const props = __props;
    const emit = __emit;
    const statusMap = {
      0: {
        text: text.draft,
        class: 'bg-slate-100 text-slate-600'
      },
      1: {
        text: text.executing,
        class: 'bg-blue-100 text-blue-700'
      },
      2: {
        text: text.completed,
        class: 'bg-green-100 text-green-700'
      },
      3: {
        text: text.cancelled,
        class: 'bg-red-100 text-red-700'
      },
      4: {
        text: text.pendingApproval,
        class: 'bg-amber-100 text-amber-700'
      },
      6: {
        text: text.approvalRejected,
        class: 'bg-orange-100 text-orange-700'
      }
    };
    const emptyStateClass = computed(() => {
      if (props.compactEmpty) {
        return 'rounded-lg border border-dashed border-slate-200 py-10 text-center text-sm text-slate-500';
      }
      return 'py-16 text-center';
    });
    const paginationClass = computed(() => {
      if (props.compactEmpty) {
        return 'pagination-bridge';
      }
      return 'pagination-bridge';
    });
    const formatAmount = amount => Number(amount || 0).toLocaleString();
    const getStatusClass = status => statusMap[status]?.class || 'bg-slate-100 text-slate-600';
    const getStatusText = status => statusMap[status]?.text || text.unknown;
    const canEdit = plan => [0, 1, 4, 6].includes(plan.status) || plan.isDraft === 1;
    const showApprovalAction = plan => plan?.approvalInstanceId != null;
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [__props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("table", _hoisted_5, [_createElementVNode("thead", _hoisted_6, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_7, _toDisplayString(text.proposalInfo), 1), __props.showCustomerColumn ? (_openBlock(), _createElementBlock("th", _hoisted_8, _toDisplayString(text.customer), 1)) : _createCommentVNode("", true), __props.showCompanyColumn ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(text.company), 1)) : _createCommentVNode("", true), _createElementVNode("th", _hoisted_10, _toDisplayString(text.owner), 1), _createElementVNode("th", _hoisted_11, _toDisplayString(text.totalAmount), 1), _createElementVNode("th", _hoisted_12, _toDisplayString(text.payableAmount), 1), _createElementVNode("th", _hoisted_13, _toDisplayString(text.status), 1), _createElementVNode("th", _hoisted_14, _toDisplayString(text.createTime), 1), _createElementVNode("th", _hoisted_15, _toDisplayString(text.action), 1)])]), _createElementVNode("tbody", _hoisted_16, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, n => {
        return _createElementVNode("tr", {
          key: n,
          class: "animate-pulse"
        }, [_cache[6] || (_cache[6] = _createElementVNode("td", {
          class: "data-table-td"
        }, [_createElementVNode("div", {
          class: "flex items-center gap-3"
        }, [_createElementVNode("div", {
          class: "h-10 w-10 rounded-lg bg-slate-200"
        }), _createElementVNode("div", null, [_createElementVNode("div", {
          class: "mb-2 h-4 w-32 rounded bg-slate-200"
        }), _createElementVNode("div", {
          class: "h-3 w-24 rounded bg-slate-200"
        })])])], -1)), __props.showCustomerColumn ? (_openBlock(), _createElementBlock("td", _hoisted_17, [...(_cache[4] || (_cache[4] = [_createElementVNode("div", {
          class: "h-4 w-20 rounded bg-slate-200"
        }, null, -1)]))])) : _createCommentVNode("", true), __props.showCompanyColumn ? (_openBlock(), _createElementBlock("td", _hoisted_18, [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
          class: "h-4 w-24 rounded bg-slate-200"
        }, null, -1)]))])) : _createCommentVNode("", true), _cache[7] || (_cache[7] = _createElementVNode("td", {
          class: "data-table-td"
        }, [_createElementVNode("div", {
          class: "h-4 w-20 rounded bg-slate-200"
        })], -1)), _cache[8] || (_cache[8] = _createElementVNode("td", {
          class: "data-table-td is-right"
        }, [_createElementVNode("div", {
          class: "ml-auto h-4 w-20 rounded bg-slate-200"
        })], -1)), _cache[9] || (_cache[9] = _createElementVNode("td", {
          class: "data-table-td is-right"
        }, [_createElementVNode("div", {
          class: "ml-auto h-4 w-20 rounded bg-slate-200"
        })], -1)), _cache[10] || (_cache[10] = _createElementVNode("td", {
          class: "data-table-td is-center"
        }, [_createElementVNode("div", {
          class: "mx-auto h-6 w-16 rounded-full bg-slate-200"
        })], -1)), _cache[11] || (_cache[11] = _createElementVNode("td", {
          class: "data-table-td is-center"
        }, [_createElementVNode("div", {
          class: "mx-auto h-4 w-24 rounded bg-slate-200"
        })], -1)), _cache[12] || (_cache[12] = _createElementVNode("td", {
          class: "data-table-td data-table-sticky-right data-table-sticky-action"
        }, [_createElementVNode("div", {
          class: "flex justify-center gap-2"
        }, [_createElementVNode("div", {
          class: "h-8 w-8 rounded bg-slate-200"
        })])], -1))]);
      }), 64))])])])) : __props.plans.length === 0 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([emptyStateClass.value, __props.compactEmpty ? 'data-table-empty is-compact' : 'data-table-empty'])
      }, [__props.compactEmpty ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(text.empty), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-slate-100"
      }, [_createElementVNode("svg", {
        class: "h-10 w-10 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
      })])], -1)), _createElementVNode("h3", _hoisted_19, _toDisplayString(text.empty), 1), _createElementVNode("p", _hoisted_20, _toDisplayString(__props.emptyDescription), 1)], 64))], 2)) : (_openBlock(), _createElementBlock("table", _hoisted_21, [_createElementVNode("thead", _hoisted_22, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_23, _toDisplayString(text.proposalInfo), 1), __props.showCustomerColumn ? (_openBlock(), _createElementBlock("th", _hoisted_24, _toDisplayString(text.customer), 1)) : _createCommentVNode("", true), __props.showCompanyColumn ? (_openBlock(), _createElementBlock("th", _hoisted_25, _toDisplayString(text.company), 1)) : _createCommentVNode("", true), _createElementVNode("th", _hoisted_26, _toDisplayString(text.owner), 1), _createElementVNode("th", _hoisted_27, _toDisplayString(text.totalAmount), 1), _createElementVNode("th", _hoisted_28, _toDisplayString(text.payableAmount), 1), _createElementVNode("th", _hoisted_29, _toDisplayString(text.status), 1), _createElementVNode("th", _hoisted_30, _toDisplayString(text.createTime), 1), _createElementVNode("th", _hoisted_31, _toDisplayString(text.action), 1)])]), _createElementVNode("tbody", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.plans, plan => {
        return _openBlock(), _createElementBlock("tr", {
          key: plan.id,
          class: "data-table-row cursor-pointer",
          onClick: $event => emit('detail', plan)
        }, [_createElementVNode("td", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_cache[14] || (_cache[14] = _createElementVNode("div", {
          class: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-primary-100"
        }, [_createElementVNode("svg", {
          class: "h-5 w-5 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        })])], -1)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_36, _toDisplayString(plan.name), 1), _createElementVNode("div", _hoisted_37, _toDisplayString(plan.planNo), 1)])])]), __props.showCustomerColumn ? (_openBlock(), _createElementBlock("td", _hoisted_38, [__props.customerLinkable && plan.customerId ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "text-sm text-primary-600 hover:text-primary-800 hover:underline",
          onClick: _withModifiers($event => emit('customer-click', plan), ["stop"])
        }, _toDisplayString(plan.customerName || '-'), 9, _hoisted_39)) : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(plan.customerName || '-'), 1))])) : _createCommentVNode("", true), __props.showCompanyColumn ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString(plan.companyName || '-'), 1)) : _createCommentVNode("", true), _createElementVNode("td", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-50"
        }, [_createElementVNode("svg", {
          class: "h-3 w-3 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        })])], -1)), _createElementVNode("span", null, _toDisplayString(plan.ownerUserName || '-'), 1)])]), _createElementVNode("td", _hoisted_44, "¥" + _toDisplayString(formatAmount(plan.totalAmount)), 1), _createElementVNode("td", _hoisted_45, "¥" + _toDisplayString(formatAmount(plan.payableAmount)), 1), _createElementVNode("td", {
          class: "data-table-td is-center",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [plan.isDraft === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(text.draft), 1)) : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(['status-badge', getStatusClass(plan.status)])
        }, _toDisplayString(getStatusText(plan.status)), 3)), plan.needApproval ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "ml-1 inline-flex text-amber-500",
          title: text.needApproval
        }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "currentColor",
          viewBox: "0 0 20 20"
        }, [_createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
          "clip-rule": "evenodd"
        })], -1)]))], 8, _hoisted_47)) : _createCommentVNode("", true), showApprovalAction(plan) ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          class: "table-action-button is-purple ml-1 cursor-pointer",
          title: text.viewApproval,
          "aria-label": text.viewApproval,
          onClick: _withModifiers($event => emit('approval-detail', plan), ["stop"])
        }, [...(_cache[17] || (_cache[17] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        })], -1)]))], 8, _hoisted_48)) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.$formatDateTime(plan.createTime)), 1), _createElementVNode("td", {
          class: "data-table-td data-table-sticky-right data-table-sticky-action",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [_createElementVNode("div", _hoisted_50, [_createElementVNode("button", {
          class: "table-action-button is-primary",
          title: text.viewDetail,
          "aria-label": text.viewDetail,
          onClick: $event => emit('detail', plan)
        }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        }), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        })], -1)]))], 8, _hoisted_51), canEdit(plan) ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "table-action-button is-primary",
          title: text.edit,
          "aria-label": text.edit,
          onClick: $event => emit('edit', plan)
        }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        })], -1)]))], 8, _hoisted_52)), [[_directive_permission, 'plan:edit']]) : _createCommentVNode("", true)])])], 8, _hoisted_33);
      }), 128))])]))])]), __props.plans.length > 0 && __props.showPagination ? (_openBlock(), _createBlock(AppPagination, {
        key: 0,
        pagination: __props.pagination,
        "page-sizes": [10, 20, 50],
        class: _normalizeClass(paginationClass.value),
        "total-label": `${text.total} `,
        "total-suffix": ` ${text.item}`,
        "page-size-label": text.perPage,
        "page-size-suffix": text.item,
        "prev-text": text.prev,
        "next-text": text.next,
        onPageChange: _cache[2] || (_cache[2] = $event => emit('page-change', $event)),
        onSizeChange: _cache[3] || (_cache[3] = $event => emit('size-change', $event))
      }, null, 8, ["pagination", "class", "total-label", "total-suffix", "page-size-label", "page-size-suffix", "prev-text", "next-text"])) : _createCommentVNode("", true)]);
    };
  }
};